<!-- rh.dev-gui.axkans.net -->
<!-- <ng-container *ngIf="loadContent"> -->
    <br><br>
    <p-card class="axks-dash-panel" *ngFor="let dpanel of dashPanels" [header]="dpanel.dashPanel"
        [style]="{'width': '300px','height':'250px', 'margin-bottom': '2em'}">
        <iframe [src]="dpanel.urlComplete | safeUrl" width="290" height="220" scrolling="auto" frameBorder="0"></iframe>
    </p-card>

<!-- </ng-container> -->